import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "e2d82lS5IxPTL4nQFjmWWQz", "LocalDBManager", undefined);

import { App } from "./App";
/**
 * 本地记录数据类型
 */

export var E_DBType;

(function (E_DBType) {
  E_DBType["e_musicState"] = "musicState";
  E_DBType["e_effectState"] = "effectState";
  E_DBType["e_shakeState"] = "shakeState";
  E_DBType["GuideStae"] = "guideState";
  E_DBType["Coin"] = "coin";
  E_DBType["Token"] = "token";
  E_DBType["Line_Unlock"] = "lineUnLock";
  E_DBType["Line_Own"] = "lineOwn";
  E_DBType["Line_Cur"] = "lineCur";
  E_DBType["Ball_Own"] = "ballOwn";
  E_DBType["Ball_Cur"] = "ballCur";
  E_DBType["MagnetismLv"] = "magnetismLv";
  E_DBType["AccelerateLv"] = "AccelerateLv";
  E_DBType["TollgateLv"] = "tollgateLv";
  E_DBType["Gift_Pg"] = "giftPg";
  E_DBType["Gift_LineIndex"] = "giftLineIndex";
})(E_DBType || (E_DBType = {}));

var LocalDBManager = /*#__PURE__*/function () {
  function LocalDBManager() {}

  var _proto = LocalDBManager.prototype;

  _proto.init = function init() {}
  /**
   * 音乐
   */
  ;

  _proto.clear = function clear() {
    localStorage.clear();
  };

  _createClass(LocalDBManager, [{
    key: "musicState",
    get: function get() {
      var isOpen = localStorage.getItem(E_DBType.e_musicState);
      return isOpen == "false" ? false : true;
    }
    /**
     * 音效
     */
    ,
    set: function set(isOpen) {
      localStorage.setItem(E_DBType.e_musicState, isOpen + "");
    }
  }, {
    key: "effectState",
    get: function get() {
      var isOpen = localStorage.getItem(E_DBType.e_effectState);
      return isOpen == "false" ? false : true;
    }
    /**
     * 震动状态
     */
    ,
    set: function set(isOpen) {
      localStorage.setItem(E_DBType.e_effectState, isOpen + "");
    }
  }, {
    key: "shakeState",
    get: function get() {
      var isOpen = localStorage.getItem(E_DBType.e_shakeState);
      return isOpen == "false" ? false : true;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.e_shakeState, v + "");
    }
    /**金币 - 拥有金币数量 */

  }, {
    key: "coin",
    get: function get() {
      var coin = localStorage.getItem(E_DBType.Coin);
      return coin ? parseInt(coin) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Coin, v + "");
    }
    /**皮肤 - 拥有皮肤 */

  }, {
    key: "lineOwn",
    get: function get() {
      var lineOwn = localStorage.getItem(E_DBType.Line_Own);
      return lineOwn ? lineOwn : "0";
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Line_Own, v);
    }
    /**皮肤 - 当前使用下标 */

  }, {
    key: "lineCur",
    get: function get() {
      var lineCur = localStorage.getItem(E_DBType.Line_Cur);
      return lineCur ? parseInt(lineCur) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Line_Cur, v.toString());
    }
    /**线 - 已经解锁 */

  }, {
    key: "lineUnlock",
    get: function get() {
      var lineUnlock = localStorage.getItem(E_DBType.Line_Unlock);
      return lineUnlock ? lineUnlock : "0";
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Line_Unlock, v.toString());
    }
    /**拥有的武器 */

  }, {
    key: "ballOwn",
    get: function get() {
      var ballOwn = localStorage.getItem(E_DBType.Ball_Own);
      return ballOwn ? ballOwn : "0";
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Ball_Own, v.toString());
    }
    /**当前使用的 武器 */

  }, {
    key: "ballCur",
    get: function get() {
      var ballCur = localStorage.getItem(E_DBType.Ball_Cur);
      return ballCur ? parseInt(ballCur) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Ball_Cur, v.toString());
    }
    /**引导状态 */

  }, {
    key: "guideState",
    get: function get() {
      var guideState = localStorage.getItem(E_DBType.GuideStae);
      return guideState ? parseInt(guideState) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.GuideStae, v.toString());
    }
    /**吸铁石等级 */

  }, {
    key: "MagnetismLv",
    get: function get() {
      var MagnetismLv = localStorage.getItem(E_DBType.MagnetismLv);
      return MagnetismLv ? parseInt(MagnetismLv) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.MagnetismLv, v.toString());
    }
    /**加速等级 */

  }, {
    key: "Accelerate",
    get: function get() {
      var Accelerate = localStorage.getItem(E_DBType.AccelerateLv);
      return Accelerate ? parseInt(Accelerate) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.AccelerateLv, v.toString());
    }
    /**关卡等级 */

  }, {
    key: "TollgateLv",
    get: function get() {
      var tollgateLv = localStorage.getItem(E_DBType.TollgateLv);
      return tollgateLv ? parseInt(tollgateLv) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.TollgateLv, v.toString());
    }
    /**礼物进度 */

  }, {
    key: "GiftPg",
    get: function get() {
      var GiftPg = localStorage.getItem(E_DBType.Gift_Pg);
      return GiftPg ? parseInt(GiftPg) : 0;
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Gift_Pg, v.toString());
    }
    /**线id */

  }, {
    key: "GiftLineIndex",
    get: function get() {
      var GiftLineIndex = localStorage.getItem(E_DBType.Gift_LineIndex);
      return GiftLineIndex ? parseInt(GiftLineIndex) : App.NumHandler.round_int(9, 1);
    },
    set: function set(v) {
      localStorage.setItem(E_DBType.Gift_LineIndex, v.toString());
    }
  }], [{
    key: "I",
    get: function get() {
      if (!LocalDBManager._I) {
        LocalDBManager._I = new LocalDBManager();
      }

      return LocalDBManager._I;
    }
  }]);

  return LocalDBManager;
}();

_defineProperty(LocalDBManager, "_I", null);

export { LocalDBManager as default };

_cclegacy._RF.pop();